import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faBars, faTimes, faExpand, faShoppingCart } from '@fortawesome/free-solid-svg-icons';
import { faApple, faGooglePlay } from '@fortawesome/free-brands-svg-icons';
import { useTheme } from '../contexts/ThemeContext';
import '../@style/Header.css';
import logo from '../assets/images/logo.png';
import logo2 from '../assets/images/logo2.png';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { isDarkMode, toggleTheme } = useTheme();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const openTvFullscreen = async (e) => {
    e.preventDefault();
    try {
      if (!document.fullscreenElement) {
        await document.documentElement.requestFullscreen();
      }
    } catch {
      /* tarayıcı izin vermezse yine de kur ekranına git */
    }
    navigate('/tv');
  };

  return (
    <header className={`header ${isDarkMode ? 'dark-mode' : ''}`}>
      <div className="header-container">
        {/* Logo */}
        <div className="logo">
          <div className="logo-image">
            <img 
              src={isDarkMode ? logo : logo2} 
              alt="AIFASOFT" 
              className="logo-img"
            />
          </div>
        </div>

        {/* Mobile Menu Button */}
        <button className="mobile-menu-btn" onClick={toggleMenu}>
          <FontAwesomeIcon icon={isMenuOpen ? faTimes : faBars} />
        </button>

        {/* Navigation */}
        <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
          <ul className="nav-list">
            <li>
              <a 
                href="http://engkiymetlimadenler.com.tr/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="nav-link e-ticaret-link"
                onClick={() => setIsMenuOpen(false)}
              >
                <FontAwesomeIcon icon={faShoppingCart} style={{ marginRight: '6px' }} />
                E-TİCARET
              </a>
            </li>
            <li>
              <Link 
                to="/" 
                className={location.pathname === '/' ? 'nav-link active' : 'nav-link'}
                onClick={() => setIsMenuOpen(false)}
              >
                Ana Sayfa
              </Link>
            </li>
            <li>
              <Link 
                to="/hakkimizda" 
                className={location.pathname === '/hakkimizda' ? 'nav-link active' : 'nav-link'}
                onClick={() => setIsMenuOpen(false)}
              >
                Hakkımızda
              </Link>
            </li>
            <li>
              <Link 
                to="/iletisim" 
                className={location.pathname === '/iletisim' ? 'nav-link active' : 'nav-link'}
                onClick={() => setIsMenuOpen(false)}
              >
                İletişim
              </Link>
            </li>
          </ul>
        </nav>

        {/* App Store Icons */}
        <div className="app-store-icons">
          <button
            type="button"
            className={`app-icon app-icon-tv ${location.pathname === '/tv' ? 'active' : ''}`}
            onClick={openTvFullscreen}
            title="Kur ekranı (tam ekran)"
            aria-label="Kur ekranı tam ekran"
          >
            <FontAwesomeIcon icon={faExpand} />
          </button>
          <a 
            href="https://apps.apple.com/us/app/eng-kıymetli-madenler/id6751402030" 
            target="_blank" 
            rel="noopener noreferrer"
            className="app-icon"
          >
            <FontAwesomeIcon icon={faApple} />
          </a>
          <a 
            href="https://play.google.com/store/apps/details?id=com.aifasoft.eng&hl=tr" 
            target="_blank" 
            rel="noopener noreferrer"
            className="app-icon"
          >
            <FontAwesomeIcon icon={faGooglePlay} />
          </a>
          <a 
            href="https://maps.app.goo.gl/2GVvUfnrLnFfX1aL6" 
            target="_blank" 
            rel="noopener noreferrer"
            className="app-icon"
          >
            <FontAwesomeIcon icon={faMapMarkerAlt} />
          </a>
        </div>

        {/* Toggle Switch */}
        <div className="toggle-switch">
          <input 
            type="checkbox" 
            id="toggle" 
            className="toggle-input" 
            checked={isDarkMode}
            onChange={toggleTheme}
          />
          <label htmlFor="toggle" className="toggle-label"></label>
        </div>
      </div>
    </header>
  );
};

export default Header;
